export const NETWORK = import.meta.env.VITE_PUBLIC_NETWORK;
export const X_DATA_KEY = import.meta.env.VITE_X_DATA;

export const GATA_ADDRESS = {
  mainnet: "0x46Ee3BFC281d59009cCD06F1dD6aBDbfCd82FFC3",
  testnet: "0xe3dfde754fcd7acf67ef107fe5674ecaec7c3d7c",
}[NETWORK as "mainnet" | "testnet"];

export const GATA_WALLET_ADDRESS = {
  mainnet: "0x939A9408f595828e49a76223619851548211D4a3",
  testnet: "0xe3dfde754fcd7acf67ef107fe5674ecaec7c3d7c",
}[NETWORK as "mainnet" | "testnet"];

export const ROUTER_ADDRESS = {
  mainnet: "0x1b81D678ffb9C0263b24A97847620C99d213eB14",
  testnet: "0x1b81D678ffb9C0263b24A97847620C99d213eB14",
}[NETWORK as "mainnet" | "testnet"];

export const QUOTER_ADDRESS = {
  mainnet: "0xb048bbc1ee6b733fffcfb9e9cef7375518e25997",
  testnet: "0xbC203d7f83677c7ed3F7acEc959963E7F4ECC5C2",
}[NETWORK as "mainnet" | "testnet"];

export const USDT_ADDRESS = {
  mainnet: "0x55d398326f99059fF775485246999027B3197955",
  testnet: "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
}[NETWORK as "mainnet" | "testnet"];

export const DEPOSIT_URL = {
  mainnet: "https://gata.net/app",
  testnet: "https://publicfe-gata.vercel.app/app",
}[NETWORK as "mainnet" | "testnet"];
